import { useEffect } from 'react';
import useIntegrationsStore from '@/stores/IntegrationsStore';
import { Outlet } from 'react-router-dom';
import { toast } from 'sonner';
import { useShallow } from 'zustand/react/shallow';

import { getIntegrationsStatus } from '@/hooks/integrations';

const IntegrationsLayout = () => {
  const { setIntegrations, setLoading, setError } = useIntegrationsStore(
    useShallow((state) => ({
      setIntegrations: state.setIntegrations,
      setLoading: state.setLoading,
      setError: state.setError,
    }))
  );

  useEffect(() => {
    const fetchIntegrationsStatus = async () => {
      setLoading(true);
      setError(null);
      try {
        const response = await getIntegrationsStatus();
        if (response && response.data) {
          setIntegrations(response.data);
        }
      } catch (error) {
        console.error('Failed to fetch integrations status:', error);
        setError(error);
        toast.error('Failed to load integrations status');
      } finally {
        setLoading(false);
      }
    };

    fetchIntegrationsStatus();
  }, [setIntegrations, setLoading, setError]);

  return (
    <>
      <Outlet />
    </>
  );
};

export default IntegrationsLayout;
